import { Components, Theme } from '@mui/material/styles';

export default (): Components<Theme>['MuiFormControlLabel'] => ({
  styleOverrides: {
    root: {
      fontSize: '16px',
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif'
    }
  }
});
